import * as yup from 'yup';

import { COUNTRIES } from '@wareclouds/frontend-common';

import { CONTEXT } from '@/config/consts/commons';

import {
  getDefaultProfilePhonePrefix,
  isProfilePhoneMinLength,
} from '../profilePhone';

const idField = (requiredKey) =>
  yup
    .object({
      value: yup
        .string()
        .required(requiredKey)
        .matches(/^[1-9]\d*$/, requiredKey),
      label: yup.string().required(),
    })
    .nullable()
    .required(requiredKey);

const optionalIdField = yup
  .object({
    value: yup.string().nullable(),
    label: yup.string().nullable(),
  })
  .nullable();

const phoneRegion = yup
  .string()
  .required('onboarding:complete_profile.errors.phone_required')
  .test(
    'phone-min-digits',
    'onboarding:complete_profile.errors.phone_too_short',
    (val) => isProfilePhoneMinLength(val)
  );

const regionMunicipality = {
  region: idField('onboarding:complete_profile.errors.region_required'),
  municipality: optionalIdField.when('region', (region) =>
    region?.value != null
      ? idField('onboarding:complete_profile.errors.municipality_required')
      : optionalIdField
  ),
};

const sharedProfileShape = {
  phone: phoneRegion,
  ...regionMunicipality,
};

const phoneDefault = getDefaultProfilePhonePrefix();

const baseLocationDefaults = {
  phone: phoneDefault,
  region: null,
  municipality: null,
};

const completeProfileSchemaCl = {
  schema: yup.object().shape({
    given_name: yup
      .string()
      .trim()
      .min(2, { key: 'min_length', value: 2 })
      .required('onboarding:complete_profile.errors.given_name_required'),
    middle_name: yup.string().trim().default(''),
    first_last_name: yup
      .string()
      .trim()
      .required('onboarding:complete_profile.errors.first_last_name_required'),
    second_last_name: yup
      .string()
      .trim()
      .required('onboarding:complete_profile.errors.second_last_name_required'),
    ...sharedProfileShape,
  }),
  defaultValues: {
    given_name: '',
    middle_name: '',
    first_last_name: '',
    second_last_name: '',
    ...baseLocationDefaults,
  },
};

const completeProfileSchemaBr = {
  schema: yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .min(2, { key: 'min_length', value: 2 })
      .required('onboarding:complete_profile.errors.first_name_required'),
    last_name: yup
      .string()
      .trim()
      .required('onboarding:complete_profile.errors.last_name_required'),
    ...sharedProfileShape,
  }),
  defaultValues: {
    first_name: '',
    last_name: '',
    ...baseLocationDefaults,
  },
};

export const completeProfileByCountry = {
  [COUNTRIES.CL]: completeProfileSchemaCl,
  [COUNTRIES.BR]: completeProfileSchemaBr,
};

function resolveCompleteProfileConfig(countryCode) {
  return (
    completeProfileByCountry[countryCode] ??
    completeProfileByCountry[COUNTRIES.BR]
  );
}

const activeCompleteProfile = resolveCompleteProfileConfig(CONTEXT);

export const completeProfileSchema = activeCompleteProfile.schema;

export const defaultValuesCompleteProfile = activeCompleteProfile.defaultValues;

export function getCompleteProfileFormConfig(countryCode = CONTEXT) {
  return resolveCompleteProfileConfig(countryCode);
}
